import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import Layout from 'components/Layout'
import Head from 'next/head'
import Link from 'next/link'

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(4)
  },
  question: {
    marginBottom: theme.spacing(1)
  },
  answer: {
    marginBottom: theme.spacing(4)
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}))

export default function Faq () {
  const classes = useStyles()

  return (
    <>
      <Head>
        <title>Sendung verpasst? Häufige Fragen</title>
        <meta name='description' content='Antworten auf die häufigsten Fragen der Benutzer von Sendung verpasst?' />
        <meta name='robots' content='noindex' />
      </Head>
      <Layout>
        <Typography variant='h1' component='h1' className={classes.title}>Häufige Fragen</Typography>

        <Typography variant='h5' component='h3' className={classes.question}>Was ist Sendungverpasst?</Typography>
        <div className={classes.answer}>
          Sendungverpasst ist eine Suchmaschine für das Videoangebot der traditionellen deutschen TV-Sender,
          die jeder von seinem Fernseher kennt. Angereichert mit redaktionellen Beiträgen, Empfehlungen, Top-10-Listen
          und Vielem mehr bietet Sendungverpasst den idealenen Einstiegspunkt, um sich im Dschungel des Web-TV zu orientieren.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Warum sind die Angebote der großen Video-Portale wie youtube nicht indiziert?</Typography>
        <div className={classes.answer}>
          Sendungverpasst ist gezielt auf professionell produzierte TV-Beiträge ausgerichtet.
          Das Angebot an Video-Portalen wie Youtube (und entsprechenden Meta-Portalen) ist unserer Ansicht nach bereits groß genug.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Ist eine Erweiterung auf weitere Video-Anbieter geplant?</Typography>
        <div className={classes.answer}>
          Ja. Das Video-Angebot im Web ist stetig am wachsen und wir sind ständig am erweitern.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Kann ich die Videos auch im Ausland ansehen?</Typography>
        <div className={classes.answer}>
          Die meisten Sender unterbinden Streams aus dem Ausland, vor allem bei Serien oder Sportereignissen. Dies hängt damit zusammen,
          dass sie nur über Nutzungsrechte innerhalb ihres Sendegebiets verfügen.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Ist die Nutzung von sendungverpasst legal?</Typography>
        <div className={classes.answer}>
          Ja. Sendungverpasst verweist ausschließlich auf legale und jugendfreie Inhalte. Trotzdem müssen wir als reine Suchmaschine die
          Haftung für die verlinkten Angebote ausschließen.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Ist sendungverpasst urheberrechtlich unbedenklich?</Typography>
        <div className={classes.answer}>
          Ja. Sendungverpasst ist eine reine Suchmaschine. Die Videos werden direkt auf den Seiten der TV-Sender,
          also den Rechteinhabern, betrachtet.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Sind in sendungverpasst wirklich alle Videos der deutschen TV-Sender indiziert?</Typography>
        <div className={classes.answer}>
          Wie bei jeder Suchmaschine kann es passieren, dass einzelne Inhalte von unseren Such-Robots nicht erfasst werden.
          Grundsätzlich sind jedoch mehr als 99% aller Videos erfasst.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Wie kann mein Feedback oder Verbesserungsvorschläge an sendungverpasst am Besten zukommen lassen?</Typography>
        <div className={classes.answer}>
          Im <Link href='/impressum' className={classes.link}>Impressum</Link> findet man entsprechende Möglichkeiten das Team zu kontaktieren. In der Regel bekommt man auch
          eine schnelle Antwort, sofern es sich nicht um Fragen zu einzelnen Sendungen handelt. Wir bitten um Verständnis,
          dass wir keinen kostenlosen Auskunftsdienst anbieten können.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Kann ich auf sendungverpasst eine kombinierte Stichwortsuche wie bei Google machen?</Typography>
        <div className={classes.answer}>
          Ja, gibt man 2 Suchbegriffe ein, werden nur Ergebnisse angezeigt, in deren Beschreibung beide Begriffe vorkommen.
          Setzt man die Begriffe oder einen Satz in Anführungsstriche, erhält man nur Ergebnisse, in denen die Begriffe in
          genau dieser Reihenfolge vorkommen.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Mit meinen Suchbegriffen finde ich bestimmte Videos nicht!</Typography>
        <div className={classes.answer}>
          Die Stichwortsuche läuft über den Text, mit dem die TV-Sender das Video beschreiben. Manchmal ist diese Beschreibung sehr
          knapp und enthält nur wenig "Futter" für eine Stichwortsuche. In diesem Fall ist es am besten, allgemeinere Suchbegriffe
          zu verwenden oder eine andere mögliche Schreibweise zu wählen.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Werden die Videos in sendungverpasst zeitgleich mit deren Erscheinen gelistet?</Typography>
        <div className={classes.answer}>
          Fast. Unsere Such-Roboter sind kontinuierlich in Aktion. Trotzdem können manchmal Verzögerungen bis zu einer Stunde vorkommen.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Warum werden in meinem Browser bestimmte Videos nicht angezeit?</Typography>
        <div className={classes.answer}>
          Die TV-Sender bieten verschiedene Videoformate an. Nur wenn die entsprechenden Plug-Ins oder Player auf dem Rechner installiert sind,
          können die Videos betrachtet werden.
        </div>

        <Typography variant='h5' component='h3' className={classes.question}>Brauche ich zum Betrachten der Videos einen schnellen Internetzugang (DSL, Kabel, HSDPA?)</Typography>
        <div className={classes.answer}>
          Um die Videos ohne Zeitverzögerung und Ladepausen betrachten zu können, sollte der Internetanschluss mindestens 2Mbit/s liefern.
        </div>
      </Layout>
    </>
  )
}
